import React from 'react';
import styled, { css } from 'styled-components';
import classNames from 'classnames';

import colors from '../../../style/colors';

export const badgeVariants = {
  'negative-dark': css`
    background-color: ${colors.negativeDark};
    color: ${colors.white};
  `,
  transparent: css`
    background-color: ${colors.transparent};
    color: ${colors.black};
  `,
  'action-blue': css`
    background-color: ${colors.sky};
    color: ${colors.white};
  `,
  sun: css`
    background-color: ${colors.sun};
    color: ${colors.black};
  `,
};

export const badgeSizes = {
  md: css`
    height: 14px;
    width: 14px;
    top: 1px;
    right: -3px;
    font-size: 0.5rem;
  `,

  lg: css`
    height: 16px;
    width: 16px;
    line-height: 0.875rem;
    top: 2px;
    right: -5px;
    font-size: 0.625rem;
  `,
};

interface IconBadgeProps {
  variant?: keyof typeof badgeVariants;
  size?: keyof typeof badgeSizes;
  className?: string;
  children?: React.ReactNode | string;
}

const IconBadge = styled(({ className, children }: IconBadgeProps) => (
  <span className={classNames('box-icon-badge', className)}>
    <span className={'text'}>{children}</span>
  </span>
))`
  border-radius: 4px;
  text-align: center;
  position: absolute;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ variant = 'negative-dark' }) => badgeVariants[variant]};

  ${({ size = 'lg' }) => badgeSizes[size]};
`;

export default IconBadge;
